import {assignProps} from '@sail/engine';
import {useWidget} from '../Widget/useWidget';

function findAnchor(target: HTMLElement): HTMLAnchorElement | null {
  let node = target;
  // Only walk up 10 levels for performance. If we don't find it by
  // then, we very likely are not in an anchor tag
  for (let i = 0; i < 10; i += 1) {
    if (node?.tagName === 'A') {
      return node as HTMLAnchorElement;
    }
    node = node?.parentNode as HTMLElement;
  }
  return null;
}

export function widgetLinkAction() {
  return assignProps(() => {
    const widget = useWidget();

    return {
      onClick: (e: MouseEvent) => {
        if (!e.target) {
          return;
        }

        // When clicking, elements inside the anchor tag can be
        // `e.target` if they were the thing clicked. We want the
        // actual anchor tag so we walk up the DOM tree to find it
        const anchor = findAnchor(e.target as HTMLElement);
        if (anchor == null) {
          return;
        }

        // If either the meta key (which will open it in a new window)
        // or the target is set, don't locally navigate
        if (anchor.href && !anchor.target && !e.metaKey) {
          e.preventDefault();
          widget.requestAction({name: 'navigate', data: {href: anchor.href}});
        }
      },
    };
  });
}
